<script setup lang="ts">
import AdministrationChrome from '@voix/voix-layer/components/administration/AdministrationChrome.vue'
import AdminButton from '@voix/voix-layer/components/administration/AdministrationButton.vue'
import SubmissionGroup from '@voix/voix-layer/components/administration/AdministrationSubmissionGroup.vue'
import { usePageStore } from '@voix/store/pageStore'
import { computed, defineEmits } from 'vue'

const emit = defineEmits(['new', 'select', 'close'])

const pageStore = usePageStore()
const pageTags = computed(() => pageStore.currentPage.tags || ['space', 'martians'])

function requestNewPageTag() {
  pageStore.currentPage.tags.push({ name: '', point: 1 })
}

function deleteXPTag(tag: string) {
  pageStore.removeXPTag(tag)
}
</script>

<template>
  <AdministrationChrome
    title="Manage Page Experience Tags"
    :links="[{ label: 'Add New XP Tag', emit: 'new' }]"
    :permissions="['Pages']"
    @new="requestNewPageTag"
  >
    <div class="flex-1 flex flex-col justify-between">
      <div>
        <template v-if="pageTags.length > 0">
          <div class="grid grid-cols-4 text-sm mt-2">
            <div class="border-b border-gray-300 py-2 col-span-2 flex items-center">
              Tag Name
            </div>
            <div class="border-b border-gray-300 p-2 col-span-1 flex items-center">
              Point Value
            </div>
            <div class="border-b border-gray-300 py-2 col-span-1 space-x-1 flex justify-end">&nbsp;</div>
          </div>
          <div v-for="tag in pageTags" :key="tag" class="grid grid-cols-4 text-sm ">
            <div class="border-b border-gray-300 py-2 col-span-2 flex items-center">
              <input placeholder="Tag Name" v-model="tag.name" type="text" class="border border-gray-200 rounded-sm p-2 w-full text-sm" />
            </div>
            <div class="border-b border-gray-300 p-2 col-span-1 flex items-center">
              <input placeholder="Point Value" v-model="tag.point" type="text" class="border border-gray-200 rounded-sm p-2 w-full text-sm" />
            </div>
            <div class="border-b border-gray-300 py-2 col-span-1 space-x-1 flex justify-end">
              <button class="py-2 px-3 text-xs voix-admin-bg-dark voix-admin-text-lightest rounded-sm" @click="deleteXPTag(tag)">
                Delete
              </button>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="mt-8 text-sm text-center text-gray-500 py-4 px-8 voix-admin-bg-lightest rounded voix-admin-text-dark">
            <div>No XP tags have been added to this page.</div>
            <div>
              <button class="mt-4 voix-admin-bg font-medium voix-admin-text-lightest rounded px-4 py-2" @click="requestNewPageTag">
                Add XP Tag
              </button>
            </div>
          </div>
        </template>
      </div>
      <div class="space-y-4">
        <AdministrationAlert type="warning" class="text-sm">
          <span class="font-bold">Warning:</span> By clicking "Done" you have not saved these changes. Be sure to save your changes using the save button to the left.
        </AdministrationAlert>
        <SubmissionGroup>
          <AdminButton type="primary" @click="emit('close')">
            Done
          </AdminButton>
        </SubmissionGroup>
      </div>
    </div>
  </AdministrationChrome>
</template>
